import $ from "jquery";
import "slick-carousel";
import "img-comparison-slider";
import { manageProductGridGallery } from "./product-grid-gallery";
import { manageLangSwitcher } from "./lang-switcher";
import { manageEmbedVideoModal } from "./embed-video-modal";
import { autofillEmail, manageNewsletterCta } from "./newsletter_cta";
import { manageModals } from "./modal";
import { manageNotifyWhenAvailable } from "./notify-when-available";
import { manageAccordions } from "./accordion";
import { manageNewsletterForm } from "./newsletter-form";
import { manageContactForm } from "./contact-form";
import { manageTermsAndConditions } from "./manage-terms-and-conditions";
import { manageDealerModal } from "./dealers";
import { manageChairPins } from "./chair-pins";
import { manageCatifaShipping } from "./shipping";

document.addEventListener("DOMContentLoaded", function () {
  // image gallery section carousel
  $(".image-gallery").each(function () {
    $(this)
      .find(".image-gallery__slider")
      .slick({
        dots: false,
        arrows: true,
        infinite: true,
        autoplay: true,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        variableWidth: true,
        prevArrow: $(this).find(".image-gallery__slider__arrow-prev"),
        nextArrow: $(this).find(".image-gallery__slider__arrow-next"),
        responsive: [
          {
            breakpoint: 768,
            settings: {
              arrows: false,
              dots: true,
            },
          },
        ],
      });
  });

  // Product Grid Gallery
  manageProductGridGallery();

  // Product Carousel
  $(".product-carousel").each(function () {
    $(this)
      .find(".product-carousel__slider")
      .slick({
        dots: false,
        arrows: true,
        infinite: true,
        autoplay: true,
        speed: 300,
        slidesToShow: 5,
        slidesToScroll: 1,
        prevArrow: $(this).find(".product-carousel__slider__arrow-prev"),
        nextArrow: $(this).find(".product-carousel__slider__arrow-next"),
        responsive: [
          {
            breakpoint: 1600,
            settings: {
              slidesToShow: 4,
            },
          },
          {
            breakpoint: 1144,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 990,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              arrows: false,
              dots: true,
            },
          },
          {
            breakpoint: 450,
            settings: {
              slidesToShow: 1,
              arrows: false,
              dots: true,
            },
          },
        ],
      });
  });

  // Product Compare Carousel
  $(".product-compare-carousel").each(function () {
    $(this)
      .find(".product-compare-carousel__slider")
      .slick({
        dots: false,
        arrows: true,
        infinite: true,
        autoplay: true,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: true,
        prevArrow: $(this).find(
          ".product-compare-carousel__slider__arrow-prev",
        ),
        nextArrow: $(this).find(
          ".product-compare-carousel__slider__arrow-next",
        ),
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              arrows: false,
              dots: true,
            },
          },
        ],
      });
  });

  // Video Carousel
  $(".video-carousel").each(function () {
    $(this)
      .find(".video-carousel__slider")
      .slick({
        dots: false,
        arrows: true,
        infinite: true,
        autoplay: true,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: true,
        prevArrow: $(this).find(".video-carousel__slider__arrow-prev"),
        nextArrow: $(this).find(".video-carousel__slider__arrow-next"),
        responsive: [
          {
            breakpoint: 768,
            settings: {
              arrows: false,
              dots: true,
            },
          },
        ],
      });
  });

  // Embed Video Modal
  manageEmbedVideoModal();

  // Lang/Area Switcher
  manageLangSwitcher();

  // Newsletter CTA
  manageNewsletterCta();

  // Newsletter email autofill
  autofillEmail();

  // Modals
  manageModals();

  manageNotifyWhenAvailable();

  manageAccordions();

  manageNewsletterForm();

  manageContactForm();

  manageTermsAndConditions();

  // All external link in new tab
  for (const link of Array.from(document.links)) {
    if (link!.hostname !== window.location.hostname) {
      link.target = "_blank";
      link.rel = "noreferrer noopener";
    }
  }

  manageDealerModal();

  manageChairPins();

  manageCatifaShipping();
});
